export default "__VITE_ASSET__BGJ1AQF1__"